import { render, staticRenderFns } from "./FeatureFlagsManager.vue?vue&type=template&id=e4ada5fa&scoped=true&"
import script from "./FeatureFlagsManager.vue?vue&type=script&lang=js&"
export * from "./FeatureFlagsManager.vue?vue&type=script&lang=js&"
import style0 from "./FeatureFlagsManager.vue?vue&type=style&index=0&id=e4ada5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ada5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ada5fa')) {
      api.createRecord('e4ada5fa', component.options)
    } else {
      api.reload('e4ada5fa', component.options)
    }
    module.hot.accept("./FeatureFlagsManager.vue?vue&type=template&id=e4ada5fa&scoped=true&", function () {
      api.rerender('e4ada5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Config/FeatureFlagsManager.vue"
export default component.exports